import { TableActionTh } from '@/components/Table/styles'
import { TableHeaderContent } from '@/components/Table/TableHeaderContent'

import { TableHeaderProps } from './types'

export const TableHeader = ({
	hasLeftAction,
	table,
	hasRightAction,
}: TableHeaderProps) => {
	return (
		<thead>
			{table.getHeaderGroups().map((headerGroup) => (
				<tr key={headerGroup.id}>
					{hasLeftAction && <TableActionTh>DND placeholder</TableActionTh>}
					{headerGroup.headers.map((header) => (
						<TableHeaderContent key={header.id} header={header} table={table} />
					))}
					{hasRightAction && <TableActionTh>X</TableActionTh>}
				</tr>
			))}
		</thead>
	)
}
